export const SET_CONTENT_SEGMENTS = 'Analytics/Content/SET_CONTENT_SEGMENTS';

export const SET_DOWNLOADS = 'Analytics/Content/SET_DOWNLOADS';

export const SET_SELECTED_SEGMENTS = 'Analytics/Content/SET_SELECTED_SEGMENTS';

export const SET_TABS_ROUTES = 'Analytics/Content/SET_TABS_ROUTES';
